export const pickRandomIndexFromList = (list : any[]) : any => {
    const index = Math.floor(Math.random() * list.length);
    return index;
}